"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKChangeIndicator = void 0;
var React = __importStar(require("react"));
var components_1 = require("../../../components");
var common_1 = require("../../../common");
require("./GKChangeIndicator.css");
/**
 * Small widget that displays a percentage change. Positive percentages are rendered as green/good with an upwards trend arrow,
 * while negative percentages are red/bad with a downwards trend arrow. 0 is neutral.
 */
var GKChangeIndicator = function (props) {
    var _a = (0, common_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-change-indicator",
        className: "d-flex",
    }), changeLabelText = _a.changeLabelText, changePercent = _a.changePercent, changeMessage = _a.changeMessage, mergedProps = __rest(_a, ["changeLabelText", "changePercent", "changeMessage"]);
    var changeStyling = changePercent > 0
        ? { name: components_1.GKIconName.TrendUp, color: "success" }
        : changePercent < 0
            ? { name: components_1.GKIconName.TrendDown, color: "danger" }
            : { name: components_1.GKIconName.TrendNeutral, color: "muted" };
    var absoluteChange = Math.abs(changePercent);
    var formattedChange = changeMessage !== null && changeMessage !== void 0 ? changeMessage : absoluteChange + "%";
    return (React.createElement("div", __assign({}, mergedProps),
        React.createElement("div", { className: "change-percentage text-" + changeStyling.color + " text-center flex-grow-1" },
            React.createElement(components_1.GKIcon, { name: changeStyling.name }),
            React.createElement("br", null),
            formattedChange),
        React.createElement("div", { className: "change-description text-black-50 px-2" },
            React.createElement("div", null, changeLabelText))));
};
exports.GKChangeIndicator = GKChangeIndicator;
exports.default = exports.GKChangeIndicator;
